// extracted by mini-css-extract-plugin
export default {"avatarImage":"profile_avatarImage__X4m6d","avatarPosition":"profile_avatarPosition__IyeQ9","uploadButton":"profile_uploadButton__i8mk0"};